module.exports = __webpack_public_path__ + "fonts/d41f95d0ff5b6bcefa62fec7660f4981.txt";